var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import mediaQueries from "syf-component-library/const/mediaQueries";
import { Inset } from "syf-component-library/ui/spacing";
import { BodyManage, FullWidthWrapper, HeaderWrapper, TitleManage, } from "../ui/subcomponents";
import getTranslation from "../strings/getTranslations";
export var MainContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-grow: 1;\n  display: flex;\n\n  @media ", " {\n    width: 100%;\n  }\n"], ["\n  flex-grow: 1;\n  display: flex;\n\n  @media ", " {\n    width: 100%;\n  }\n"])), mediaQueries.greaterThanSmall);
export var Content = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  @media ", " {\n    padding: 0 3rem;\n  }\n"], ["\n  display: flex;\n  @media ", " {\n    padding: 0 3rem;\n  }\n"])), mediaQueries.greaterThanMedium);
export var CenterContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n"])));
export var ProfileLayout = function (_a) {
    var children = _a.children;
    var t = getTranslation().t;
    return (_jsx(Content, { children: _jsx(CenterContainer, { children: _jsx(MainContent, { children: _jsxs(FullWidthWrapper, { children: [_jsxs(HeaderWrapper, { children: [_jsx(Inset, { top: "medium" }), _jsx(TitleManage, __assign({ "data-cy": "profileTitle" }, { children: t("labels.title") })), _jsx(Inset, { top: "medium" }), _jsx(BodyManage, { children: t("labels.header") }), _jsx(Inset, { bottom: "large" })] }), children] }) }) }) }));
};
var templateObject_1, templateObject_2, templateObject_3;
